import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as signinActions from '../../actions/signinActions';
import 'react-toastify/dist/ReactToastify.css';
import Moment from 'react-moment';
import * as constant from '../../constants/constant';

import {
	Modal,
} from 'react-bootstrap';
//login container component
class Signin extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			forgotModalOpen: false,
		};
	}

	render() {
		var rows = [];
		var heading = this.props.heading;
		var patientId = this.props.patientId;
		console.log("patienId", this.props);
		debugger
		if (heading == 'Uploaded Symptoms') {
			rows.push(
				<div style={{ 'white-space': 'pre-line', 'word-break': 'break-all' }}>
					{this.props.data.symptoms}
				</div>
			)
		} else {
			{this.props.data != undefined ? this.props.data.forEach(function (item, index) {
				if (heading == 'Prescriptions') {
					{
						item._id != null && item.appointmentStatus != '3' && item.appointmentStatus != '4' && item.appointmentStatus != '1' ?
							rows.push(
								<div id={index} key={index}>
									<Moment format="DD-MMM-YYYY">{item.checkappointmentDate}</Moment> : {item.prescription ? <a key={index} href={constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.patientId + "/" + item.prescription} target="_blank">Prescription</a> : ''}
								</div >
							) : 'No Record Found'
					}
				} else if (heading == 'Uploaded Documents') {
					rows.push(
						// <div><Moment format="DD-MMM-YYYY">{item.createdAt}</Moment> : {JSON.stringify(item)}</div>
						<div id={index} key={index}>
							{item.documentTypeId.name} :  {item.documentUrl ? <a key={index} href={constant.PRODUCTION_IMAGE_URL + 'uploads/' + patientId + "/" + item.documentUrl} target="_blank">{item.documentOriginalName}</a> : ''}
						</div>
					)
				} 
				else {
					{
						item.appointmentId != null && item.appointmentId.appointmentStatus != '3' && item.appointmentId.appointmentStatus != '4' && item.appointmentId.appointmentStatus != '1' ?
							rows.push(
								<div id={index} key={index}>
									<Moment format="DD-MMM-YYYY">{item.appointmentId.appointmentDate != null ? item.appointmentId.appointmentDate : new Date()}</Moment> : {item.description ? item.description : ''}
								</div>
							)
							: ''
					}
				}
			})
		:
	"No Record Found"}
		}
		return (
			<Modal show={this.props.openModal} size="modal-sm" onHide={this.props.hideconsultationModal}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.hideconsultationModal} /> */}
					<div className="signIn">{this.props.heading}</div>
				</Modal.Header>
				<Modal.Body>
					<div className="consultation-popup">{rows.length > 0 ? rows : <div className='text-center'>No Record Found</div>}</div>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
function mapStateToProps(state, ownProps) {
	return {
		signin: state.signin
	};
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(signinActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Signin);
